module.exports = __webpack_public_path__ + "static/media/fvs_valve1_113.469d08f8.jpg";